import { render, staticRenderFns } from "./formulaMedicaComponent.vue?vue&type=template&id=2e769728&scoped=true&"
import script from "./formulaMedicaComponent.vue?vue&type=script&lang=js&"
export * from "./formulaMedicaComponent.vue?vue&type=script&lang=js&"
import style0 from "./formulaMedicaComponent.vue?vue&type=style&index=0&id=2e769728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e769728",
  null
  
)

export default component.exports